// Rich text with popup functionality
function initTrailerModal() {
  const modal = document.getElementById("trailerModal");
  const closeBtn = modal.querySelector(".close-modal");
  const siteControl = document.querySelector(".site-control");
  const popupTrigger = document.querySelector(".popup-trigger");
  const pdfLink = document.querySelector(".pdf-link");

  function openTrailerModal() {
    modal.style.display = "block";
    document.body.style.overflow = "hidden";
    if (siteControl) {
      siteControl.style.zIndex = "unset";
    }
  }

  function closeTrailerModal() {
    modal.style.display = "none";
    document.body.style.overflow = "";
    if (siteControl) {
      siteControl.style.zIndex = "25";
    }
  }

  // Add event listeners
  if (popupTrigger) {
    popupTrigger.addEventListener("click", openTrailerModal);
  }

  closeBtn.addEventListener("click", closeTrailerModal);

  modal.addEventListener("click", function (event) {
    if (event.target === modal) {
      closeTrailerModal();
    }
  });

  // Check URL parameters to auto-open popup
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get("open_popup") === "true") {
    setTimeout(openTrailerModal, 500);
  }

  // Keep this for backward compatibility
  window.openTrailerModal = openTrailerModal;
}

// PDF generation function
function generatePDF(companies) {
  // Initial PDF setup
  let pdf = "%PDF-1.7\n%\xFF\xFF\xFF\xFF\n\n";
  let objPositions = [];
  let currentObjNumber = 1;

  function addObject(content) {
    objPositions.push(pdf.length);
    pdf += `${currentObjNumber} 0 obj\n${content}\nendobj\n\n`;
    currentObjNumber++;
  }

  // Add standard objects (Catalog, Pages, Page, Font)
  addObject("<<\n/Type /Catalog\n/Pages 2 0 R\n>>");
  addObject("<<\n/Type /Pages\n/Kids [3 0 R]\n/Count 1\n>>");
  addObject(
    "<<\n/Type /Page\n/Parent 2 0 R\n/Resources <<\n/Font <<\n/F1 4 0 R\n>>\n>>\n/MediaBox [0 0 612 792]\n/Contents 5 0 R\n>>"
  );
  addObject("<<\n/Type /Font\n/Subtype /Type1\n/BaseFont /Helvetica\n>>");

  // Create content stream
  let content = "BT\n";
  let yPos = 750;
  const pageWidth = 612;
  const margin = 50;
  const columnWidth = (pageWidth - margin * 3) / 2;
  let currentColumn = 0;

  // Add title
  content += `/F1 16 Tf\n${margin} ${yPos} Td\n(Trailer Companies Information) Tj\nET\n`;
  yPos -= 30;

  // Process companies
  companies.forEach((company, index) => {
    // Modified heading cleaning to preserve hyphens and dashes
    const heading = company.heading
      .replace(/<[^>]*>/g, "") // Remove HTML tags
      .replace(/[()\\]/g, "\\$&") // Escape parentheses and backslashes
      .replace(/–/g, "-") // Replace en dash with hyphen
      .trim();
    const description = company.description
      ? company.description.replace(/<[^>]*>/g, "").replace(/[()\\]/g, "\\$&")
      : "";

    // First company (Greenlite)
    if (index === 0) {
      content += `BT\n/F1 12 Tf\n${margin} ${yPos} Td\n(${heading}) Tj\nET\n`;
      yPos -= 25;

      if (description) {
        const words = description.split(" ");
        let line = "";
        words.forEach((word) => {
          if ((line + " " + word).length > 80) {
            content += `BT\n/F1 10 Tf\n${margin} ${yPos} Td\n(${line}) Tj\nET\n`;
            yPos -= 15;
            line = word;
          } else {
            line += (line ? " " : "") + word;
          }
        });
        if (line) {
          content += `BT\n/F1 10 Tf\n${margin} ${yPos} Td\n(${line}) Tj\nET\n`;
          yPos -= 20;
        }
      }

      // Contact info for first company
      if (company.phone) {
        content += `BT\n/F1 10 Tf\n${margin} ${yPos} Td\n(Phone: ${company.phone}) Tj\nET\n`;
        yPos -= 15;
      }
      if (company.email) {
        content += `BT\n/F1 10 Tf\n${margin} ${yPos} Td\n(Email: ${company.email}) Tj\nET\n`;
        yPos -= 15;
      }
      if (company.website) {
        content += `BT\n/F1 10 Tf\n${margin} ${yPos} Td\n(Website: ) Tj\n0 0.2 0.4 rg\n(${company.website}) Tj\n0 0 0 rg\nET\n`; // #003366 only for URL
        yPos -= 15;
      }

      yPos -= 20; // Extra space after first company
    }
    // Last company
    else if (index === companies.length - 1) {
      let xPos = margin;
      yPos -= 20;

      content += `BT\n/F1 12 Tf\n${xPos} ${yPos} Td\n(${heading}) Tj\nET\n`;
      yPos -= 20;

      if (company.phone) {
        content += `BT\n/F1 10 Tf\n${xPos} ${yPos} Td\n(Phone: ${company.phone}) Tj\nET\n`;
        yPos -= 15;
      }
      if (company.email) {
        content += `BT\n/F1 10 Tf\n${xPos} ${yPos} Td\n(Email: ${company.email}) Tj\nET\n`;
        yPos -= 15;
      }
      if (company.website) {
        content += `BT\n/F1 10 Tf\n${xPos} ${yPos} Td\n(Website: ) Tj\n0 0.2 0.4 rg\n(${company.website}) Tj\n0 0 0 rg\nET\n`; // #003366 only for URL
        yPos -= 15;
      }
    }
    // Middle companies in two columns
    else {
      let xPos = margin + currentColumn * (columnWidth + margin);

      content += `BT\n/F1 12 Tf\n${xPos} ${yPos} Td\n(${heading}) Tj\nET\n`;
      yPos -= 20;

      if (company.phone) {
        content += `BT\n/F1 10 Tf\n${xPos} ${yPos} Td\n(Phone: ${company.phone}) Tj\nET\n`;
        yPos -= 15;
      }
      if (company.email) {
        content += `BT\n/F1 10 Tf\n${xPos} ${yPos} Td\n(Email: ${company.email}) Tj\nET\n`;
        yPos -= 15;
      }
      if (company.website) {
        content += `BT\n/F1 10 Tf\n${xPos} ${yPos} Td\n(Website: ) Tj\n0 0.2 0.4 rg\n(${company.website}) Tj\n0 0 0 rg\nET\n`; // #003366 only for URL
        yPos -= 15;
      }

      if (company.instagram_link) {
        content += `BT\n/F1 10 Tf\n${xPos} ${yPos} Td\n(Instagram: ) Tj\n0 0.2 0.4 rg\n(${company.instagram_link}) Tj\n0 0 0 rg\nET\n`; // #003366 only for URL
        yPos -= 15;
      }

      // Switch columns
      if (currentColumn === 0) {
        currentColumn = 1;
        yPos += 20 + 15 * 3; // Reset Y position for next column
      } else {
        currentColumn = 0;
        yPos -= 20; // Extra space between row pairs
      }
    }
  });

  // Add content stream
  addObject(`<< /Length ${content.length} >>\nstream\n${content}\nendstream`);

  // Finalize PDF
  const xrefPosition = pdf.length;
  pdf += "xref\n";
  pdf += `0 ${currentObjNumber}\n`;
  pdf += "0000000000 65535 f\n";
  objPositions.forEach((pos) => {
    pdf += `${pos.toString().padStart(10, "0")} 00000 n\n`;
  });
  pdf += "trailer\n";
  pdf += `<<\n/Size ${currentObjNumber}\n/Root 1 0 R\n>>\n`;
  pdf += "startxref\n";
  pdf += `${xrefPosition}\n`;
  pdf += "%%EOF";

  const bytes = new Uint8Array(pdf.length);
  for (let i = 0; i < pdf.length; i++) {
    bytes[i] = pdf.charCodeAt(i);
  }

  try {
    const blob = new Blob([bytes], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "trailer-companies.pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error generating PDF:", error);
  }
}
